const config = {
    team: {
        id: "137104", // ID de l'équipe utilisé dans les requêtes
        logoUrl: "https://cdn-transverse.azureedge.net/phlogos/BC553688.jpg", // Logo de l'équipe
    },
    colors: {
        primary: "#000", // Couleur principale
        secondary: "#fff", // Couleur secondaire
        or: "#FFD700",
        background: "#F5F5F5", // Couleur de fond
    },
    api: {
        baseUrl: "https://api-dofa.fff.fr/api", // URL de l'API
    },
};

export default config;
